
import React from "react";
import ClaroImage from '../../molecules/ClaroImage'
import ClaroParagraph from '../../atoms/ClaroParagraph'
import ClaroPadding from '../../atoms/ClaroPadding'
import ClaroButton from '../../atoms/ClaroButton'
import ClaroInputBlock from '../ClaroInputBlock'
import ClaroChipsBlock from '../ClaroChipsBlock'
import { GenericFormContext } from '../../../context/genericFormContext';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ClaroModalCardOk, ClaroTooltip, ClaroModalCardError } from "@claropay/shared";
import _ from 'lodash';
import { getAmountOfTelcelPospago, getUserInfo, getPaymentMethods, getCommissionRules } from '../../../store/actions';
import * as sdkclaro from '@claropay/claro-pay-sdk-v2';
import { mask } from '../GenericForm/utils/maskAmount'
import { ClaroModalCardLoader } from "@claropay/shared";

var showInputCcv = false;
class GenericForm extends React.Component {

    constructor(props, context){
        super(props, context)
        this.state = {
            fields:[],
            buttonState:{
                disabled:true
            },
            productID:0,
            amountNumber:0,
            selectedValue:this.context.selectedItemId,
            validForm:false,
            serviceId: this.props.serviceId,
            openModal: false,
            setAmountFromInput: false,
            buttonText: "Continuar",
            showClaroVideoTitle: false,
            titleModal: "Favor de intentar de nuevo o ingresa otro número",
            subtitleModal: "",
            imgModal:"data:image/png;base64,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",
            openToolTip: false,
            addCloseEfect: false,
            textTitleTooltip: "",
            imgTooltip: "",

            comisionTitle: false,
            textTitleComision: "Total de comisiones*:",

            //comissionnService
            comisionService:0,
            comisionTotal: 0,
            //comisionCard
            comisionCard: 0,
            comisionCardPorcent: 0,
            comisionMontoFijo: 0,
            
            activeValueOcr: false,
            selectCurrentValue:0,
            //imageCard:"",
            selectCardId: "",
            openModalUpdateCard: false,
            selectRef : "",
            setAmoutn: false
        }
        this.smoothScroll = this.smoothScroll.bind(this);
        this.s = new Set()
    }

    componentDidMount() {
        const  appServiceData  = this.props.paymentsConfigArrayServices[this.props.serviceKey].serviceData;
        
        /*let comisionConfig  = appServiceData.generic.amount.feeAmount;
        
        if(comisionConfig !== 0){
            let comisionConfigDouble = parseFloat(comisionConfig).toFixed(2);
            this.setState({
                //comissionnService
                comisionService: comisionConfigDouble,
                comisionTotal: comisionConfigDouble

            });
        }*/

        //let _item = _.find(appServiceData.generic.elements, ['id', "cardId"]);
        
        if(appServiceData.info && appServiceData.info.logicType=="claroVideo"){
            this.setState({
                //buttonState:{disabled:false}, 
                //validForm:true,
                buttonText:"Contrátalo  Ahora",
                showClaroVideoTitle: true
            });
        }
        /*if(_item &&_item.field.itemsList.lengh != 0){
            this.props.getPaymentMethods();
            this.setState({comisionTitle: true});
        }*/
    }



    handleValidation(value, pattern) {
        if (!pattern) return true;
        // string pattern, one validation rule
        if (typeof pattern === 'string') {
          const condition = new RegExp(pattern, 'i');
          let result = condition.test(value)
          return result;
        }
        // array patterns, multiple validation rules
        if (typeof pattern === 'object') {
          const conditions = pattern.map(rule => new RegExp(rule, 'g'));
          return conditions.map(condition => condition.test(value));
        }
    }

    onclickModal = () => {
        this.setState({openModal:false});
        document.getElementById("pagoDeServicios_lineaCaptura_" + this.props.serviceName ).focus();
    }

    smoothScroll = () => {
        if(this.props.amountTelcelPospago){
            let image = this.state.imgModal;
            switch (this.props.amountTelcelPospago.messageType) {
                case 1:
                  image="data:image/png;base64,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"
                  break;
                case 2:
                  image="data:image/png;base64,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"
                  break;
            }
            
             this.setState({
                titleModal:this.props.amountTelcelPospago.responseSubject, 
                subtitleModal:this.props.amountTelcelPospago.responseMessage,
                imgModal: image,
            });
            if(this.props.amountTelcelPospago.responseCode == 0){
                this.context.getAmountFromOcrData(this.props.amountTelcelPospago.pendingAmount);
                this.setState({/*buttonState:{disabled:false}, validForm:true,*/ setAmountFromInput:false, setAmoutn: true});
            }else{
                this.setState({
                    openModal:true,
                    buttonState:{disabled:true}, 
                    validForm:false
                });
            }
        }else{
            this.setState({
                openModal:true,
                buttonState:{disabled:true}, 
                validForm:false
            });
        }
    }

    handleClickConfigOptions = (event, onclickAction) =>{
        switch (onclickAction) {
            case 'setFocusFieldAmount':
                document.getElementById("pagoDeServicios_monto_" + this.props.serviceName).focus();
              break;
            case 'setAmountTelcelPostago':
                setTimeout( this.smoothScroll , 1000);
              break;
            default:
              console.log('default');
        }
    }

    handleClickTooltip = (event) => {
        const dataType = event.target.getAttribute('data_type');
        let textTitleTooltip = "";
        let imgTooltip = "";
        switch(dataType){
            case 'contacts':
            case 'ocr':
                textTitleTooltip = "En el siguiente ejemplo encontraras los datos necesarios para pagar tu servicio.";
                imgTooltip = this.props.paymentsConfigArrayServices[this.props.serviceKey].serviceData.generic.imgTooltip;
                break
            case 'cvv':
                textTitleTooltip = ""
                imgTooltip = "/images/cvv.png"
                break
        }
        this.setState({ 
            addCloseEfect:false, 
            openToolTip:true,
            textTitleTooltip : textTitleTooltip,
            imgTooltip : imgTooltip
        });
    }

    onclickCloseTooltip = () => {
        this.setState({addCloseEfect:true});
        setTimeout(function() {
            this.setState({openToolTip: false})
        }.bind(this), 900);
    }

    handleClickSelectBlock = () => {
        const  appServiceData  = this.props.paymentsConfigArrayServices[this.props.serviceKey].serviceData;
        let _item = _.find(appServiceData.generic.elements, ['id', "cardId"]);
    if(_item &&_item.field.itemsList.lengh != 0 && this.props.sdkVersion !== undefined){
            this.props.getPaymentMethods();
            this.setState({comisionTitle: true});
            if(this.props.isLoadingGetPaymentMethods){
                console.log(this.props.isLoadingGetPaymentMethods, "ÑÑÑÑÑÑÑ");
            }
        }     
    }
    
    handleInputChange = (event, valueSelectBlock, ref) => {
        if(valueSelectBlock || valueSelectBlock == ""){
            event = {
                target: {
                    name: "cardId",
                    type: "select-one",

                }
            };
        }
        if((event && event.target && event.target.name && event.target.type) || (event && event.value) ){
            let itemFieldName = (event && event.target && event.target.name && event.target.type)? event.target.name : event.name
            let itemFieldType = (event && event.target && event.target.name && event.target.type)? event.target.type : event.type
            let fieldsForValidation = 0
            let { elements } = this.props
            let validInputOcr = false;
            let itemFieldValue = (event && event.target && event.target.name && event.target.type) ? event.target.value : event.value
            itemFieldValue = (valueSelectBlock || valueSelectBlock == "")?valueSelectBlock:itemFieldValue;
            console.log(`#### itemFieldValue: ${itemFieldValue}`)
            console.log(`#### itemFieldName: ${itemFieldName}`)
            console.log(`#### itemFieldType ${itemFieldType}`)

            let _item = _.find(elements, ['id', itemFieldName]);

            console.log(`#### item_id ${_item.id}`);
            console.log(`#### item_type ${_item.type}`);
            if(_item.id == "amount"){
                //comisionCard

                let comisionCard = ((parseFloat(itemFieldValue) * this.state.comisionCardPorcent)/100) + this.state.comisionMontoFijo;
                
                //comissionnService
                let comisionTotal = comisionCard + parseFloat(this.state.comisionService);
                
                this.setState({
                    comisionCard: comisionCard.toFixed(2),
                    comisionTotal: comisionTotal.toFixed(2),
                })

                this.setState({setAmountFromInput: true}); 
                
                itemFieldValue = (itemFieldValue == "")?"0":itemFieldValue;
                let maxAmount = (_item.range)?_item.range.max:0;

                let { maskedValue } = mask(itemFieldValue, maxAmount);
                
                const { getAmountFromOcrData } = this.context;
                getAmountFromOcrData(maskedValue);

                itemFieldValue = parseFloat(maskedValue.replace(/,/g, ''));

                this.setState({activeValueOcr: false})
            }
            let { contactNumber, setNumberContact, ocrScannerData:{data=''}, setOCRScannerData } =  this.props
            if(contactNumber){
                //alert("2");
                setNumberContact(null)
            }
            if(data){
                //alert("3");
                setOCRScannerData(null)
            }

            if(_item.distpatchGetAmount && itemFieldValue.length == 10){
                this.props.getAmountOfTelcelPospago(itemFieldValue, this.state.serviceId);
            }

            let _select_chips = _.find(elements, ['type', 'select-chips']);

            if(_item.id == "cardId"){
                let selectedItemTarget = document.querySelector(`[data-card-id='${valueSelectBlock}']`);
                let updateCard = selectedItemTarget.getAttribute("data-update-card");
                /*if(itemFieldValue == "agregar-targeta") {
                    ref.current.__reset(); 
                    sdkclaro.getInstance().openWallet("openWallet")
                }*/

                if(updateCard == "true") {
                    this.setState({openModalUpdateCard:true, cardId: valueSelectBlock, selectRef: ref.current});
                }
            }
            if(_item.id == "cardId" && valueSelectBlock !="" && itemFieldValue != "agregar-targeta"){
                
                
                /// calculo nuevas comisiones

                let selectedItemTarget = document.querySelector(`[data-card-id='${valueSelectBlock}']`);

                let mark = selectedItemTarget.getAttribute("data-mark");
                let selectCardId = valueSelectBlock;
                let cardType = selectedItemTarget.getAttribute("data-type")
                let amountValueForCommission = 0;

                if(_select_chips){
                    amountValueForCommission = this.context.selectedItemAmount;
                } else {
                    amountValueForCommission = parseFloat(this.context.ocrAmountValue.replace(/,/g, ""));
                }

                if(itemFieldValue != "" && itemFieldValue != "agregar-targeta" ){
                    this.props.getCommissionRules(
                        this.state.serviceId, 
                        amountValueForCommission,
                        mark,
                        selectCardId,
                        cardType,
                        this.props.sdkVersion
                    ); 
                }               

                let comisionCard;
                //let comisionFromTargetSelectOption = event.target.options[event.target.selectedIndex].dataset.comision;

                /*let imageCard="";
                switch(mark) {
                    case "1":
                        imageCard = "/images/visa@3x.png";
                        break;
                    case "2":
                        imageCard = "/images/mastercard@3x.png";
                        break;
                    case "3":
                        imageCard = "/images/amex@3x.png";
                        break;
                    case "4":
                        imageCard = "/images/carnet.png";
                        break;
                    case "999":
                        imageCard = "/images/claroPay.png"
                }*/
                //comisionCard
                /*if(_select_chips){
                    comisionCard = (this.context.selectedItemAmount * comisionFromTargetSelectOption)/100;
                } else {
                    comisionCard = (parseFloat(this.context.ocrAmountValue.replace(/,/g, "")) * comisionFromTargetSelectOption)/100;
                }*/
                //comissionnService
                //let comisionTotal = comisionCard + parseFloat(this.state.comisionService);
                
                this.setState({
                    //comisionCard: comisionCard.toFixed(2),
                    //comisionTotal: comisionTotal.toFixed(2),
                    //comisionCardPorcent: comisionFromTargetSelectOption,
                    //imageCard : imageCard,
                    selectCardId: selectCardId,
                })

                
                setTimeout(
                    function(){ 
                        console.log(JSON.stringify(this.props.commissionRules), "ñññññññ"); 
                        console.log(this.props.commissionRules[0].cvv, "ñññññññ"); 
                        if(!this.props.commissionRules[0].cvv){
                            document.getElementById("pagoDeServicios_cvv_" + this.props.serviceName).value= "";
                            document.getElementById("cvv-container-input").style.display = "none";
                            this.s.delete("cvv")
                            showInputCcv= false;
                        }else{
                            document.getElementById("cvv-container-input").style.display = "block";
                            showInputCcv= true;
                            this.setState({
                                buttonState:{
                                    disabled:true,
                                }
                            }) 
                        }


                        if(_select_chips){
                            comisionCard = (this.context.selectedItemAmount)
                        } else {
                            comisionCard = (parseFloat(this.context.ocrAmountValue.replace(/,/g, "")));
                        }
                         
                        let comisionCardPorcent =  comisionCard * (this.props.commissionRules[0].comisionMetodoPagoPorcentaje / 100);
                        comisionCard = comisionCardPorcent + this.props.commissionRules[0].comisionMetodoPagoFijo;
                        this.setState({
                            comisionService: this.props.commissionRules[0].comisionServicio,
                            comisionCard: comisionCard,
                            comisionCardPorcent: this.props.commissionRules[0].comisionMetodoPagoPorcentaje,
                            comisionTotal: this.props.commissionRules[0].comisionServicio + comisionCard,
                            comisionMontoFijo: this.props.commissionRules[0].comisionMetodoPagoFijo
                        })
                    }
                    .bind(this),
                    2500
                );

                /*if(event.target.options[event.target.selectedIndex].dataset.showCvvField == "true"){
                    document.getElementById("pagoDeServicios_cvv_" + this.props.serviceName).value= "";
                    document.getElementById("cvv-container-input").style.display = "none";
                    this.s.delete("cvv")
                    showInputCcv= false;
                }else{
                    document.getElementById("cvv-container-input").style.display = "block";
                    showInputCcv= true;
                }*/
            }
            if(_item.id == "cvv" && itemFieldValue.length > 4){
                itemFieldValue = itemFieldValue.substr(0,4)
                document.getElementById("pagoDeServicios_cvv_" + this.props.serviceName).value= itemFieldValue;
                
            }
            if(elements && elements.length >0){
                fieldsForValidation = elements.filter(element => element.constraints).length  
                let inputCardId = _.find(elements, ['id', "cardId"]);
                if(inputCardId && !showInputCcv){
                    fieldsForValidation --
                    if(this.props.sdkVersion === undefined){
                        fieldsForValidation --
                    }
                }
                if(this.state.activeValueOcr && _item.id != "amount"){
                    fieldsForValidation --
                }


            }
    
            console.log(`#### ${itemFieldName}  constraints ---> ${JSON.stringify(_item.constraints)}`)
    
            if(_item !== undefined){

                if( _item.id === "destAccountId" ){

                    


                    if(_item.upercase){
                        itemFieldValue = itemFieldValue.toUpperCase();
                    }

                    const { multipleServiceIds } = this.props;
                    if(multipleServiceIds){
                        if(itemFieldValue.length == multipleServiceIds.ocr.referenceLength){
                            this.setState({serviceId: multipleServiceIds.ocr.serviceId});
                        }
                        if(itemFieldValue.length == multipleServiceIds.manual.referenceLength){
                            this.setState({serviceId: multipleServiceIds.manual.serviceId});
                        }
                    }


                    let actualValue = this.context.ocrAmountValue;

                    if(_item.type == "ocr"){
                        
                        let { amountSubstr } = _item;
                            
                        let originalData = data;
                        let dataValid = (data && data.length > 0);

                        if(
                            amountSubstr && 
                            amountSubstr.denomination && 
                            amountSubstr.positionSubtractInitial &&
                            amountSubstr.positionSubtractFinal && 
                            dataValid &&
                            data !== ""
                        ) {
                            let  amount = originalData.substring(
                                amountSubstr.positionSubtractInitial, 
                                amountSubstr.positionSubtractFinal + 1 
                            );

                            if(amount === "" || isNaN(amount)){
                                amount = 0;
                            }else{
                                if(amountSubstr.denomination === "centavos"){
                                    amount = amount / 100;
                                } else if(amountSubstr.denomination === "pesos"){
                                    amount = parseFloat(amount);
                                }
                            }
                            this.context.getAmountFromOcrData(amount);
                            actualValue = amount;
                            if(!this.state.activeValueOcr){
                                fieldsForValidation --
                            }   
                            this.s.delete("amount")
                            this.setState({activeValueOcr: true})
                        }
                    }

                            

                    //comisionCard
                    let comisionCard = (parseFloat(actualValue) * this.state.comisionCardPorcent)/100 + this.state.comisionMontoFijo;
        
                    //comissionnService
                    let comisionTotal = comisionCard + parseFloat(this.state.comisionService);
                    
                    this.setState({
                        comisionCard: comisionCard.toFixed(2),
                        comisionTotal: comisionTotal.toFixed(2),
                    })










                }

                //Validaciones REGEX
                if((_item.constraints !== undefined) && (Object.getOwnPropertyNames(_item.constraints).length >= 1)){
                    let isValid = this.handleValidation(itemFieldValue, _item.constraints);
                    //alert("entro regex");
                    
                    console.log(`#### para ${itemFieldName} y ${itemFieldValue} el resultado es: ${isValid}, `)
        
                    let generalValidationResult = isValid.includes(false)
                    if(!generalValidationResult){
                        console.log(`#### las validaciones REGEX PASARON para el valor de ${itemFieldName}`)
                        if(_item.range && _item.range.min && _item.range.max){
                            //alert("item range");
                            if((itemFieldValue >= _item.range.min) && (itemFieldValue <= _item.range.max)){
                                //alert("item max");
                                    this.s.add(`${itemFieldName}`)
    
                                    this.setState({
                                        fields:{
                                            ...this.state.fields,
                                            [`${itemFieldName}`]:{
                                                ...this.state.fields[`${itemFieldName}`],
                                                itemFieldType,
                                                value:itemFieldValue,
                                                valid:true
                                            }
                                        }
                                    })
    
                            }else{
                                    this.s.delete(`${itemFieldName}`)
                                    this.setState({
                                        fields:{
                                            ...this.state.fields,
                                            [`${itemFieldName}`]:{
                                                ...this.state.fields[`${itemFieldName}`],
                                                itemFieldType,
                                                value:itemFieldValue,
                                                valid:false
                                            }
                                        }
                                    })
                            }
    
                        }else{
                            //alert("no entro item range");
                            this.s.add(`${itemFieldName}`)
                            if(itemFieldName == "destAccountId" && this.context.ocrAmountValue !== "0"){
                                validInputOcr = true;
                            }
                            //alert(JSON.stringify(this.props.amountTelcelPospago));
                            this.setState({
                                fields:{
                                    ...this.state.fields,
                                    [`${itemFieldName}`]:{
                                        ...this.state.fields[`${itemFieldName}`],
                                        itemFieldType,
                                        value:itemFieldValue,
                                        valid:true
                                    }
                                }
                            })
                        }
    
                    }else{
                        console.log(`#### las validaciones TRONARON, el valor de ${itemFieldName}`);
                        this.s.delete(`${itemFieldName}`)

                        if((itemFieldName !== undefined && itemFieldName != "amount") || (itemFieldName == "amount" && itemFieldValue > 0)){
                            this.setState({
                                fields:{
                                    ...this.state.fields,
                                    [`${itemFieldName}`]:{
                                        ...this.state.fields[`${itemFieldName}`],
                                        itemFieldType,
                                        value:itemFieldValue,
                                        valid:false
                                    }
                                }
                            })
                        }
        
                    }
                }else{
                    //alert("no entro a regex");
                    this.setState({
                        fields:{
                            ...this.state.fields,
                            [`${itemFieldName}`]:{
                                ...this.state.fields[`${itemFieldName}`],
                                itemFieldType,
                                value:itemFieldValue
                                
                            }
                        }
                    })
                }

            }else{
                this.setState({
                    fields:{
                        ...this.state.fields,
                        [`${itemFieldName}`]:{
                            ...this.state.fields[`${itemFieldName}`],
                            itemFieldType,
                            value:itemFieldValue
                            
                        }
                    }
                })
            }
            


            if(_item.id == "cardId"){
                if(itemFieldValue == "agregar-targeta") {
                    ref.current.__reset(); 
                    this.s.delete(itemFieldName);
                    sdkclaro.getInstance().openWallet("openWallet")
                } else{
                    if(this.state.setAmoutn){fieldsForValidation --}
                }
            }

            console.log(`####---> fieldsForValidation ${fieldsForValidation}`)
            console.log(`####---> s.size ${this.s.size}`)
            if(this.s.size === fieldsForValidation){
                    let isSizeCorrect = this.s.size === fieldsForValidation ? true:false
    
                    if(_select_chips){
                        if(this.state.selectedValue > 0){
                            this.setState({
                                validForm:true,
                                isSizeCorrect,
                                buttonState:{
                                    disabled:false,
                                }
                            }) 
                        }else{
                            this.setState({
                                validForm:true,
                                isSizeCorrect,
                                buttonState:{
                                    disabled:true,
                                }
                            }) 
                        }
                    
                    }else{
                        this.setState({
                            validForm:true,
                            isSizeCorrect,
                            buttonState:{
                                disabled:false,
                            }
                        }) 
                    }

            } else {

                let isSizeCorrect = this.s.size === fieldsForValidation ? true:false;              
                if(itemFieldName == "description"){
                    let descriptionElement = _.find(elements, ['id', 'description']);
                    if(
                        descriptionElement.constraints === undefined && 
                        this.state.validForm == true &&
                        this.state.buttonState.disabled == false
                    ){
                        this.setState({
                            validForm:true,
                            buttonState: {disabled:false}
                        });
                    }
                
                }else if(validInputOcr && itemFieldName == "destAccountId"){
                    /*this.setState({
                        validForm:false,
                        isSizeCorrect,
                        buttonState:{
                            disabled:false,
                        }
                    })*/
                }else{
                    this.setState({
                        validForm:false,
                        isSizeCorrect,
                        buttonState:{
                            disabled:true,
                        }
                    })
                }
               
                let ocrElement = _.find(elements, ['id', "destAccountId"]);
                if(ocrElement && ocrElement.amountSubstr){

                    //this.setState({ validForm:true})
                }
            }
            
        } else {
            console.log(JSON.stringify(event)  + "despues de que no entro");
            if(event.name){
                let _item = _.find(this.props.elements, ['id', event.name]);
                if(_item){
                    if(_item.type =="ocr" && this.context.ocrAmountValue != "0"){

                        let amountItem = _.find(this.props.elements, ['id', "amount"]);
                        if(amountItem){

                            let floatAmount = parseFloat(this.context.ocrAmountValue);

                            if(amountItem.range){

                                if(floatAmount > amountItem.range.max){
                                    /*this.setState({
                                        buttonState:{
                                            disabled:true,
                                        }
                                    });*/

                                } else if(floatAmount < amountItem.range.max && this.state.fields.destAccountId.valid){
                                    /*this.setState({
                                        buttonState:{
                                            disabled:false,
                                        }
                                    });*/
                                }
                            } else{
                                /*alert();
                                this.setState({
                                    buttonState:{
                                        disabled:false,
                                    }
                                });*/
                            }
                        }
                    }
                }
            }
        } 
    }

    handleClick = (e) => {
        var { elements, destAccountIdType, amount, logo:{data:{base64}} } =  this.props
        
        let { validForm, fields } = this.state
        
        if(validForm){
            let item = {}
            item[`destAccountIdType`] = destAccountIdType
            item[`serviceId`] = this.state.serviceId
            item[`feeAmount`] = amount.feeAmount
            item[`logo`] = base64
            item[`category`] = "MF"
            item[`amount`] = this.context.selectedItemAmount;
            item[`productId`] = this.context.selectedItemId;
            
            const appInfo = this.props.paymentsConfigArrayServices[this.props.serviceKey].serviceData.info;
            if(appInfo && appInfo.logicType=="claroVideo"){
                item[`amount`] = appInfo.staticAmount;
                item[`productId`] = appInfo.productId;
                item['destAccountId'] = this.props.userInfo.msisdn.slice(3, 13);
                item['description'] = "Compra Claro Video 1 Mes";
        

            }
            //console.log(JSON.stringify(fieldAmountSelectChip), "fieldamountselectchip");
            for(let f in fields){

                if( fields[f].itemFieldType === "select-chips"){

                    let _item =  elements && f ? _.find(elements, ['id', f]) : []

                    let itemsList =  _item && _item.field && _item.field.itemsList && _item.field.itemsList.length > 0 ? _item.field.itemsList : []

                    let productID = fields[f].value
                    //console.log(JSON.stringify(fields[f]), "fieldsxd");
                    //console.log(JSON.stringify(this.context.selectedItemId), "contextxd");

                    item[`productId`] = this.context.selectedItemId
                    
                    let amountNumber = _.find(itemsList, {productID});
                   
                    amountNumber = amountNumber && amountNumber.amount !== undefined ? amountNumber.amount : 0

                    item[`amount`] = amountNumber
                }else{
                    //console.log("entro segundo");
                    item[`${f}`] = fields[f].value
                    
                    let ocrElement = _.find(elements, ['id', "destAccountId"]);

                    if(ocrElement && ocrElement.amountSubstr && this.context.ocrAmountValue){
                        item[`amount`] = parseFloat(this.context.ocrAmountValue.replace(/,/g, ''));
                    }
                }
            }

            let fieldAmountSelectChip  = this.props.payments.PAYMENT_SERVICE_CONF.services[this.props.serviceKey].serviceData.generic.elements.find(element => element.id == "destAccountId");
            if(fieldAmountSelectChip  && fieldAmountSelectChip.distpatchGetAmount){
                if(this.props.amountTelcelPospago.responseCode == 0 && !this.state.setAmountFromInput){
                    item[`amount`] = this.props.amountTelcelPospago.pendingAmount;
                }
            }

            const dataContact = Object.values(this.props.dataContact);
            const contacts = Object.values(this.props.contactsList);

            if(dataContact.length != 0 && contacts.lengh != 0){

                let contactRecentIsContact = contacts.filter(contact => contact.displayName ==  this.props.dataContact.fullName )
              
                if(contactRecentIsContact.length > 0 ){
                    this.props.addContactToRecents(this.props.dataContact, this.props.serviceId);
                }   
            }

            if(item['description'] == undefined || item['description'] == ""){
                item['description'] = "PAGO DE " + this.props.serviceName.toUpperCase();
            }
            let itemInputCardId = _.find(this.props.paymentsConfigArrayServices[this.props.serviceKey].serviceData.generic.elements, ['id', "cardId"]);

            if(!showInputCcv && itemInputCardId){
                delete item["cvv"];
            }

            let { selectCardId } = this.state;
            if(selectCardId != ""){
                let itemCardInfo = this.props.paymentMethods.cardList.filter(function(item) { return item.cardId === selectCardId });
                item['cardInfo'] = itemCardInfo[0]
                if(selectCardId =="claro-pay"){
                    item['cardInfo'] = {cardId:"claro-pay"}
                }
            }
            console.log(JSON.stringify(item), "enviado a form");

            this.props.setPaymentServiceData(item)
        }
        
        e.preventDefault();
    }

    handleButtonCardClick = (e) => {}

    handleButtonOCRClick = (e) => {
        let { getOCRScanner = () => console.warn('getOCRScanner() not defined')} = this.props       
        getOCRScanner();
    }

    handleButtonContactsClick = (e) => { 
        window.bandera= 2;    
        sdkclaro.getInstance().switchGoBackButton(true)
        console.log(history);
        console.log(history.length, "antesxd");
        if(history.length < 2){
            var stateObj = { foo: "contacts" };  
            history.replaceState(stateObj, "page 2", "contacts");
        }
        console.log(history);
        console.log(history.length, "despuesxd");
        let {changeDisplay = () => console.warn('changeDisplay() not defined')} = this.props
            changeDisplay("form")
    }

    handleClickChip= (event) => {
        if(this.state.isSizeCorrect){
            this.setState({
                ...this.state,
                buttonState:{
                    disabled:false,
                }
            })
        }

        let itemFieldId = event.target.id
        let itemFieldName = event.target.name
        let itemFieldType = event.target.type

        //console.log(`#### itemFieldName: ${itemFieldName}`)
        //console.log(`#### itemFieldType ${itemFieldType}`)
        //console.log(`#### itemFieldId ${itemFieldId}`)
        if(itemFieldId === this.state.selectedValue){
            this.setState({
                selectedValue:'',
                buttonState:{
                    disabled:true,
                }
            }) 
        }else{
            this.setState({
                selectedValue:itemFieldId,
            })

        }
        this.setState({
            fields:{
                ...this.state.fields,
                [`${itemFieldName}`]:{
                    ...this.state.fields[`${itemFieldName}`],
                    itemFieldType,
                    value:itemFieldId,
                    valid:true
                }
            }
        })
        
        let fieldAmountSelectChip  = this.props.payments.PAYMENT_SERVICE_CONF.services[this.props.serviceKey].serviceData.generic.elements.find(element => element.id == "amount");
        fieldAmountSelectChip = fieldAmountSelectChip.field.itemsList.find(e => e.productID == itemFieldId);
        this.context.handleClickSelectedChip({
            selectedItemId:itemFieldId,
            selectedItemAmount:fieldAmountSelectChip.amount
        }); 
        //comisionCard
        let comisionCard = ((fieldAmountSelectChip.amount * this.state.comisionCardPorcent)/100) + this.state.comisionMontoFijo;
        //comissionnService
        let comisionTotal = comisionCard + parseFloat(this.state.comisionService); 
        
        this.setState({
            comisionCard: comisionCard.toFixed(2),
            comisionTotal: comisionTotal.toFixed(2)
        })
    }
    
    dataEnrichment = (item, onChange, onClick, ocrData, valueContact) => {

        let stateItem = this.state.fields && this.state.fields[[`${item.id}`]] ? this.state.fields[[`${item.id}`]]:undefined

        let isValid = undefined
        
        let { serviceName } = this.props.payments.PAYMENT_SERVICE_CONF.services[this.props.serviceKey].serviceData.info;
        //comissionnService
        let { comisionTitle, textTitleComision, comisionTotal, comisionCard, comisionService, selectCurrentValue } = this.state
        if(stateItem){

            let {valid} = stateItem

            

            isValid = valid

        }
        let handleClickSelectBlock = this.handleClickSelectBlock;
        if(ocrData !== null){
            document.addEventListener("onautochange", function(e) {
                console.log(e.detail); // Prints "Example of an event"
            });

            return {
                ...item,
                field:{
                    ...item.field,
                    input:{
                        ...item.field.input,
                        onChange,
                        handleClickSelectBlock,
                        isValid,
                        value:ocrData
                    },
                    button:{
                        ...item.field.button,
                        onClick
                    },
                    div:{
                        ...item.field.input,
                        onClick
                    }
                },
                serviceName: serviceName,
                comisionTitle: comisionTitle,
                textTitleComision,
                comisionTotal: parseFloat(comisionTotal).toFixed(2),
                comisionCard: parseFloat(comisionCard).toFixed(2),
                comisionService: parseFloat(comisionService).toFixed(2),
                selectCurrentValue,
                //imageCardProps: this.state.imageCard
            }
        }else if (valueContact !== null){
            document.addEventListener("onautochange", function(e) {
                console.log(e.detail); // Prints "Example of an event"
            });
            // console.log(JSON.stringify(item))
            // console.log(item.id)
            //  let element = document.getElementById(item.id);
            //  console.log("data")
            //  let obj = event.value
            // var ev = new CustomEvent('valueContact', {
            //     detail: {
            //         target: valueContact
            //     }});
             //this.handleInputChange(ev)
            //  element.dispatchEvent(ev);
            // element.dispatchEvent(new Event('onchange', { 'bubbles': true }));

            return {
                ...item,
                field:{
                    ...item.field,
                    input:{
                        ...item.field.input,
                        onChange,
                        handleClickSelectBlock,
                        isValid,
                        value:valueContact
                    },
                    button:{
                        ...item.field.button,
                        onClick
                    },
                    div:{
                        ...item.field.input,
                        onClick
                    }
                },
                serviceName: serviceName,
                comisionTitle: comisionTitle,
                textTitleComision,
                comisionTotal: parseFloat(comisionTotal).toFixed(2),
                comisionCard:parseFloat(comisionCard).toFixed(2),
                comisionService : parseFloat(comisionService).toFixed(2),
                selectCurrentValue,
                //imageCardProps: this.state.imageCard
            }
        }else{
            return {
                ...item,
                field:{
                    ...item.field,
                    input:{
                        ...item.field.input,
                        onChange,
                        handleClickSelectBlock,
                        isValid
                    },
                    button:{
                        ...item.field.button,
                        onClick
                    },
                    div:{
                        ...item.field.input,
                        onClick
                    }
                },
                serviceName: serviceName,
                comisionTitle: comisionTitle,
                textTitleComision,
                comisionTotal: parseFloat(comisionTotal).toFixed(2),
                comisionCard: parseFloat(comisionCard).toFixed(2),
                comisionService: parseFloat(comisionService).toFixed(2),
                selectCurrentValue,
                //imageCardProps: this.state.imageCard
            }
        }
    }

    onclickUpdateCard = (event) => {
        this.state.selectRef.__reset();
        this.s.delete("cardId");
        this.setState({
            openModalUpdateCard:false,
            buttonState:{
                disabled:true,
            }
        })
        if(event.target.textContent == "Actualizar ahora"){
            sdkclaro.getInstance().openWallet("openWallet-" + this.state.selectCardId)
        }
    }

    render(){
        let { logo, elements, serviceTitleLabel, ocrScannerData:{data=null}, contactNumber } =  this.props
        let button = {
            align : {
                center:true
            },
            weight : {
                bold:true
            },
            style: {
                normal:true
            }
        } 


        let mainTitle = {
            "align" : {
                "center":true
            },
            "padding": "15px 0 0 0",
        } 

        const { getAmountFromOcrData } = this.context;
        let claroVideoTitle = "";

        if(this.state.showClaroVideoTitle){
            claroVideoTitle = <ClaroParagraph fontSize="22px" {...mainTitle.align} fontFamily="Roboto" 
                margin="0px 0px 10px 0px" 
            >Contrata un mes</ClaroParagraph>
        }
        
        return(
            <div>
                <ClaroParagraph id="title" {...mainTitle.align} >
                    <ClaroPadding padding={mainTitle.padding}>
                        {serviceTitleLabel}
                    </ClaroPadding>
                </ClaroParagraph>
                <ClaroImage {...logo.data} />
                {claroVideoTitle}
                
                {elements.map((item) => {

                    let newItem = {}
                    switch(item.type){
                        case 'card':
                            newItem = this.dataEnrichment(item, this.handleInputChange, this.handleButtonCardClick, null, null)
                            return <ClaroInputBlock {...newItem} handleClickTooltip ={this.handleClickTooltip}  />
                        case 'ocr':

                            let { referenceSubstr } = item;
                            
                            let originalData = data;
                            let dataValid = (data && data.length > 0);
                            if((referenceSubstr && referenceSubstr.length == 2) && dataValid ) {
                                data = originalData.substring(referenceSubstr[0], referenceSubstr[1]);
                            }
                            /*if(
                                amountSubstr && 
                                amountSubstr.denomination && 
                                amountSubstr.positionSubtractInitial &&
                                amountSubstr.positionSubtractFinal && 
                                dataValid &&
                                data !== ""
                            ) {
                                let  amount = originalData.substring(
                                    amountSubstr.positionSubtractInitial, 
                                    amountSubstr.positionSubtractFinal + 1 
                                );

                                if(amount === "" || isNaN(amount)){
                                    amount = 0;
                                }else{
                                    if(amountSubstr.denomination === "centavos"){
                                        amount = amount / 100;
                                    } else if(amountSubstr.denomination === "pesos"){
                                        amount = parseFloat(amount);
                                    }
                                }
                                alert(amount + "lli");
                                getAmountFromOcrData(amount);
                            }

                            const valueData = data === "" ? null : data;*/
                            newItem = this.dataEnrichment(
                                item,
                                this.handleInputChange,
                                this.handleButtonOCRClick, 
                                data, 
                                null
                            );

                            return <ClaroInputBlock {...newItem} handleClickTooltip ={this.handleClickTooltip}/>

                        case 'contacts':
                            newItem = this.dataEnrichment(item, this.handleInputChange, this.handleButtonContactsClick, null, contactNumber)
                            return <ClaroInputBlock {...newItem} handleClickTooltip ={this.handleClickTooltip}/>
                        case 'select':
                            if(this.props.sdkVersion !== undefined){
                                newItem = this.dataEnrichment(item, this.handleInputChange, ()=>{}, null, null)
                                return false
                            }else{
                                return "";
                            }
                            
                        case 'select-chips': 
                            newItem = this.dataEnrichment(item, () => {}, this.handleClickChip, null, null)
                            return <ClaroChipsBlock selected={this.state.selectedValue} {...newItem}/>
                        
                        case 'button':
                                return <ClaroButton 
                                    width="42%!important" 
                                    backgroundColor="#ffffff" 
                                    onClick={(e) => this.handleClickConfigOptions(e, item.onclickAction)}
                                    color="#50626b!important"
                                    border="solid"
                                    borderColor="#eeeeee"
                                    lineHeight="normal!important"
                                    height="37px"
                                    margin="6% 4% 0% 4%"
                                >   
                                    {item.title.text}
                                </ClaroButton>
                        case 'commission':
                            return <></>;
                        default:
                            newItem = this.dataEnrichment(
                                item, 
                                this.handleInputChange, 
                                null, 
                                null, 
                                null
                            );

                            return <ClaroInputBlock {...newItem} handleClickTooltip ={this.handleClickTooltip} />
                    }                 
                })}
              
                <ClaroPadding padding='2%'>
                    <ClaroParagraph {...button.align} {...button.weight} {...button.style}>
                        <ClaroButton id="claro_button" backgroundColor="#000000" {...this.state.buttonState} onClick={this.handleClick}>
                            {this.state.buttonText}
                        </ClaroButton>
                    </ClaroParagraph>
                </ClaroPadding>
                <ClaroModalCardOk
                    isOpen={this.state.openModal}
                    backgroundColor="rgba(0,0,0,0.65)"
                    borderRadiusCard="5px"
                    fontFamilyTitle="Nunito"
                    heightImg="62px"
                    widthImg="62px"
                    backgroundColorButton="#202020"
                    srcImage={this.state.imgModal}
                    text= {this.state.titleModal}
                    textdetail={this.state.subtitleModal}
                    buttontext="Entendido"
                    height="100%"
                    onclickModal={this.onclickModal}
                    onClickImg={this.onclickModal}
                />
                
                <ClaroModalCardOk
                    isOpen={this.state.openModalUpdateCard}
                    backgroundColor="rgba(0,0,0,0.65)"
                    borderRadiusCard="5px"
                    fontFamilyTitle="Nunito"
                    heightImg="62px"
                    widthImg="62px"
                    backgroundColorButton="#202020"
                    srcImage="data:image/png;base64,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"
                    text= "¡Hey!"
                    buttontext="Actualizar ahora"
                    textdetail="Es necesario que actualices los datos de esta tarjeta para que puedas utilizarla"
                    height="100%"
                    onclickModal={this.onclickUpdateCard}
                    textLink="Hacerlo en otro momento"
                    fontFamilyLinkButton=""
                    textDecorationLinkButton="underline"
                    fontSizeDetail="12px"
                    textAlignLinkButton="center"
                    textSizeLinkButton="10px"
                    widthLinkButton="100%"
                    textTransformLinkButton="initial"
                    fontWeightLinkButton="bold"
                />

                <ClaroTooltip 
                    isOpen={this.state.openToolTip}
                    addCloseEfect={this.state.addCloseEfect}
                    onclickCloseTooltip = {this.onclickCloseTooltip}
                    text={this.state.textTitleTooltip}
                    srcImage={this.state.imgTooltip}
                    colorButton ='#797878' 
                    fontSizeTitle="12px"
                    height="92%"
                    colorTitle ='#B2B2B2'
                    fontSizeButton="22px!important"
                    paddingTitle="10px 20px"
                    marginButton="0px -12px 10px 10px"
                    fadeInTime="1s"
                    fadeIn
                    cubicBezier="cubic-bezier(0.9, 0, 0.9, 1)"
                    widthImg="85%"
                >                    
                </ClaroTooltip>
                <div>
                    {this.props.isLoadingGetPaymentMethods || this.props.isLoadingCommisSionRules? (
                    <ClaroModalCardLoader
                        boxShadow="none!important"
                        backgroundColor="rgba(0,0,0,0.65)"
                        heightLoader="150px"
                        isOpen={true}
                        srcImage="https://logos.claropay.com/ClaroPayLoading2.gif"
                        widthLoader="150px"
                    />
                    ) : (
                    <div />
                    )}
                </div>
            </div>
                
        )
    }
}

GenericForm.contextType = GenericFormContext;

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
      {
        getAmountOfTelcelPospago,
        getUserInfo,
        getPaymentMethods,
        getCommissionRules
      },
      dispatch,
    );
  }


function mapStateToProps(state) {
  
    return { 
        amountTelcelPospago: state.payments.amountTelcelPospago,
        userInfo: state.payments.userInfo,
        paymentMethods: state.payments.paymentMethods,
        isLoadingGetPaymentMethods: state.payments.isLoadingGetPaymentMethods, 
        isLoadingCommisSionRules: state.payments.isLoadingCommisSionRules, 
        commissionRules: state.payments.commissionRules
    };
}


GenericForm = connect(
    mapStateToProps,
    mapDispatchToProps
  )(GenericForm);

export default GenericForm